const menuList3 = [
/*   { title: 'Nosotros', to: '#!' },
  { title: 'Contactos', to: '#!' }, */
  { title: 'info@homelanapp.com', iconsrc: 'Icono Finanzas 2.png'},
  { title: '+58 414-5253897', iconsrc: 'Icono Finanzas 2.png'}
];
export default menuList3
